export const classes = {
  wrapper: 'place-start',
  slider: 'w-[200px] mx-4 py-0',
};
